export const DepositMethodType = {
  QR: "QR",
  Offline: "Offline",
  ABC: "ABC",
  DT: "DT",
  GatewayHub: "GatewayHub",
  PayzEasy: "PayzEasy",
};

export const DepositPaymentMethod = {
  BankTransfer: "bank transfer",
  BankTransferAlt: "Bank Transfer",
  Gpay: "gpay",
  Paytm: "paytm",
  Phonepe: "phonepe",
  Bhim: "bhim",
  Crypto: "crypto",
  Dragon: "dt",
  GatewayHub: "gatewayhub",
  Favorite: "favorite",
};